export default __webpack_public_path__ + "static/media/dp-big--portfolio-09.905218e2.jpg";